import { get, patch, post, invokeApi, createAdditionalParams, fetchFile } from './index';

export const getPortfolios = async () => {
  const additionalParams = await createAdditionalParams();

  return invokeApi({}, `portfolios`, get, additionalParams);
};

export const getPortfolioDetail = async ({ portfolioId, termId }) => {
  const additionalParams = await createAdditionalParams();
  const requestQuery = termId ? `?simulationTermId=${termId}` : '';

  return invokeApi({}, `portfolio/${portfolioId}${requestQuery}`, get, additionalParams);
};

export const createApGroup = async ({ serviceId, requestBody }) => {
  const additionalParams = await createAdditionalParams();

  return invokeApi({}, `${serviceId}/ap_groups`, post, additionalParams, requestBody);
};

export const updateApGroupParentInfo = async ({ requestBody }) => {
  const additionalParams = await createAdditionalParams();

  return invokeApi({}, `ap_group_parent_info`, patch, additionalParams, requestBody);
};

export const fetchFileFromS3 = ({ filePath }) => fetchFile({}, filePath, get);
